export type Preferences = {
  preferredLanguage?: string;
  notificationPreferences?: any;
  /**
   * Appearance: 'system' | 'light' | 'dark'. Typed as `string` to mirror the
   * schema, so a value written by a newer client still parses here rather
   * than failing type-narrowing; `useSetDefaultTheme` validates before use.
   */
  theme?: string;
};

export type NotificationPreferences = {
  newIssueSeverities?: string[];
  issueReplies?: boolean;
  issueSeverityChanges?: boolean;
  issueTitleChanges?: boolean;
  labelIds?: string[];
  groupIds?: string[];
  campaignMessages?: boolean;
};

export const defaultNotificationPreferences: NotificationPreferences = {
  newIssueSeverities: ['blue', 'yellow', 'red', 'purple'],
  issueReplies: true,
  issueSeverityChanges: true,
  issueTitleChanges: true,
  labelIds: [],
  groupIds: [],
  campaignMessages: true,
};

export enum NotificationSchedule {
  EveryDay = 'EVERY_DAY',
  WeekDays = 'WEEK_DAYS',
}
